import React from "react";
import "./Characters.css";

const Characters = () => {
  return (
    <div className="characters">
      <div className="wrapper">
        <div className="characters-intro-heading">
          <h2>Osoby autentyczne</h2>
        </div>
      </div>
      <div className="characters-specialization">
        <h3>Pan Młody</h3>
        <p>
          <b>Lucjan Rydel</b> był młodopolskim poetą. W&nbsp;1900 roku ożenił
          się z&nbsp;<b>Jadwigą Mikołajczykówną</b>, siostrą Anny Tetmajerowej.
          Wesele odbyło się w&nbsp;dworku Tetmajerów, w&nbsp;podkrakowskich
          <b> Bronowicach</b>. Pan Młody w&nbsp;„Weselu” jest sportretowany
          ironicznie, popełnia liczne gafy, np. zdejmuje buty, chcąc
          zaakcentować swoją chłopskość.
        </p>
        <br />
        <h3>Panna Młoda</h3>
        <p>
          Mikołajczykówna w&nbsp;1890 roku wyszła za Lucjana Rydla. Panna Młoda
          w&nbsp;„Weselu” została sportretowana jako typowa chłopka, pewna
          siebie, temperamentna. Upomina męża co do obyczajów obowiązujących na
          wsi.
        </p>
        <br />
        <h3>Dziennikarz</h3>
        <p>
          <b>Rudolf Starzewski</b> był redaktorem krakowskiego „Czasu”.
          W&nbsp;dramacie <b>Dziennikarz</b> to człowiek inteligentny,
          o&nbsp;artystycznej naturze, ale jednocześnie zachowawczy i
          &nbsp;pogrążony w&nbsp;apatii.
        </p>
        <br />
        <h3>Poeta</h3>
        <p>
          <b>Kazimierz Tetmajer</b>, przyrodni brat Włodzimierza, był słynnym
          młodopolskim poetą, a&nbsp;także autorem dramatów i&nbsp;powieści.
          W&nbsp;„Weselu” podkreśla się skłonność <b>Poety</b> do romansów
          i&nbsp;jego dekadencką naturę.
        </p>
        <br />
        <h3>Radczyni</h3>
        <p>
          <b>Antonina Domańska</b> była żoną profesora UJ, a&nbsp;także pisarką.
          Ciotka Lucjana Rydla w&nbsp;dramacie prezentuje niechęć do
          młodopolskiej chłopomanii.
        </p>
        <br />
        <h3>Gospodarz</h3>
        <p>
          <b>Tetmajer</b> był młodopolskim malarzem, pochodził z&nbsp;rodziny
          inteligenckiej. W&nbsp;1890 roku ożenił się z&nbsp;chłopką, Anną
          Mikołajczykówną. Związek ów uchodził za mezalians, którego początkowo
          nie akceptowała ani rodzina, ani środowisko malarza. Małżeństwo było
          jednak udane, a&nbsp;Tetmajerowie z&nbsp;czasem dorobili się własnego
          dworu i&nbsp;cieszyli się szacunkiem. W&nbsp;dramacie Gospodarz jest
          wcieleniem polskości, oddaje jednak nieopatrznie
          <b> złoty róg Jaśkowi</b>.
        </p>
        <br />
        <h3>Gospodyni (Anna Tetmajerowa)</h3>
        <p>
          <b>Anna Tetmajerowa</b>, z&nbsp;domu Mikołajczykówna,
          z&nbsp;pochodzenia chłopka, wyszła za&nbsp;Włodzimierza Tetmajera
          w&nbsp;1890 roku. W dramacie wzór matki i&nbsp;żony, każe schować
          podkowę.
        </p>
        <br />
        <h3>Rachela</h3>
        <p>
          <b>Pepa Singer</b> była córką bronowickiego karczmarza, Żydówką.
          W&nbsp;dramacie <b>Rachela</b> jest postacią fascynującą
          i&nbsp;tajemniczą, poetką i&nbsp;znawczynią sztuki.
        </p>
        <br />
        <h3>Czepiec (Błażej Czepiec)</h3>
        <p>
          <b>Czepiec</b> był wujem Panny Młodej. W&nbsp;Bronowicach był pisarzem
          gminnym. Podczas wesela wszczyna bójkę i&nbsp;upija się. Jest
          krytykiem mieszczańskich wad, ale jednocześnie patriotą.
        </p>
        <br />
        <h3>Jasiek (brat Panny Młodej)</h3>
        <p>
          Był drużbą na ślubie Lucjana Rydla z&nbsp;Jadwigą. W&nbsp;dramacie
          gubi złoty róg, gdy schyla się po czapkę z&nbsp;pawich piór.
        </p>
        <br />
        <h3>Marysia (Marysia Mikołajczykówna)</h3>
        <p>
          <b>Marysia</b> była siostrą Panny Młodej, jej narzeczony (malarz
          Ludwik de&nbsp;Levaux) zmarł za granicą na gruźlicę. Marysia wyszła
          potem za <b>Wojtusia</b>, który również zmarł. W dramacie ukazuje się
          jej dawny ukochany.
        </p>
        <br />
        <h3>Nos (Tadeusz Nosowski lub Stanisław Czajkowski)</h3>
        <p>
          W dramacie przedstawiciel krakowskiej cyganerii, wcielenie
          przybyszewszczyzny. Jego cechy charakterystyczne to zamiłowanie do
          alkoholu i&nbsp;dekadenckiego sposobu myślenia.
        </p>
        <br />
        <h3>Zosia</h3>
        <p>
          <b>Zofia Pareńska</b>, córka znakomitego lekarza, profesora
          Uniwersytetu Jagiellońskiego i&nbsp;prymariusza szpitala św. Łazarza;
          później wyszła za mąż za&nbsp;<b>Tadeusza Boya-Żeleńskiego</b>.
        </p>
        <br />
        <h3>Haneczka</h3>
        <p>
          <b>Hana Rydlówna</b>, siostra Lucjana Rydla. Charakter wszystkich
          trzech dziewcząt, oraz ich sposób mówienia został zachowany
          w&nbsp;dramacie bardzo wiernie.
        </p>
        <br />
        <p>
          <em>
            wypracowania.pl/wypracowania/bohaterowie-wesela-i-ich-pierwowzory-opis
          </em>
        </p>
      </div>
    </div>
  );
};

export default Characters;
